// A DOMParser holds no state between calls, so one instance serves every label.
const inertHtmlParser = new DOMParser();

/**
 * Parses a label string into inert DOM child nodes using an HTML-context
 * `DOMParser`. Parsing via `parseFromString(str, "text/html")` produces a
 * detached document: no scripts run, no resources (e.g. `<img>` `onerror`) are
 * fetched, and nothing is attached to the live document. The returned nodes are
 * only used to extract text, never re-inserted into the DOM.
 */
export function parseLabelToInertNodes(str: string): NodeListOf<ChildNode> {
    return inertHtmlParser.parseFromString(str, "text/html").body.childNodes;
}
